<!------------------------------------------------------------------------------
  - Copyright (c) 2019. BMW Group. All rights reserved.
  ----------------------------------------------------------------------------->

<app-generic-modal (primaryActionEvent)="save()"
                   [primaryActionEnabled]="isValid"
                   [primaryActionTitle]="primaryActionTitle"
                   [title]="title"
                   secondaryActionTitle="Discard">
    <div class="business-modal-body">
        <app-input-textarea #description
                            (inputValueChange)="descriptionInputChange($event)"
                            [messages]="descriptionMessages"
                            [warningLevel]="WarningsEnum.WARNING_SAVE"
                            baseCypressTag="business-settings-warning-modal-description"
                            height="200"
                            label="Warning message"
                            maxLength="300"
                            placeholder="Please, write a warning message"></app-input-textarea>
        <app-active-input (checkState)="setActiveInputState($event)" [entityName]="ENTITY_NAME"
                          [state]="$safeNavigationMigration(state?.isActive)"></app-active-input>
    </div>
</app-generic-modal>
